// Helper to generate sequential image paths
const imgs = (folder, count) =>
  Array.from({ length: count }, (_, i) => `/projects/${folder}/image-${String(i + 1).padStart(2, '0')}.jpg`);

const projects = [
  { id: 1,  slug: 'project-1', name: 'Addision', images: imgs('1', 16) },
  { id: 2,  slug: 'project-2', name: 'Avoca', images: imgs('2', 21) },
  { id: 3,  slug: 'project-3', name: 'Burra', images: imgs('3', 22) },
  { id: 4,  slug: 'project-4', name: 'Capri', images: imgs('4', 16) },
  { id: 5,  slug: 'project-5', name: 'Davinci', images: imgs('5', 14) },
  { id: 6,  slug: 'project-6', name: 'Domino', images: imgs('6', 17) },
  { id: 7,  slug: 'project-7', name: 'Dublin', images: imgs('7', 19) },
  { id: 8,  slug: 'project-8', name: 'Florance', images: imgs('8', 22) },
  { id: 9,  slug: 'project-9', name: 'Frome', images: imgs('9', 22) },
  { id: 10, slug: 'project-10', name: 'Grange', images: imgs('10', 17) },
  { id: 11, slug: 'single-story', name: 'Iconic', images: imgs('single-story', 14) },
];

// thumbnail is always the first image
projects.forEach(p => { p.thumbnail = p.images[0]; });

export default projects;
